import { render } from "./Menu.vue?vue&type=template&id=82b0d784&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=82b0d784&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b0d784"]])

export default __exports__